import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import StorageRoundedIcon from "@mui/icons-material/StorageRounded";
import businessFlowsTheme, { brand } from "../../theme/businessFlowsTheme";
import "../auth/auth.css";

// Shown instead of the app when a signed-in person may open no database -
// their workspace's groups grant them none, or they belong to no workspace.
//
// It is also what a workspace with nothing in it looks like: switching to one
// that gives this person no database must say so plainly rather than leave
// another workspace's library on the chip (utils/readingContext.js). Then the
// card names the workspace and offers the way back, because the bar that
// would otherwise switch is not on screen.
export default function NoDatabaseCard({ email, onRetry, onSignOut, workspace = "", others = [], onChooseWorkspace = null }) {
  const elsewhere = onChooseWorkspace ? others : [];
  return (
    <ThemeProvider theme={businessFlowsTheme}>
      <Box
        className="bfx"
        role="alert"
        sx={{ minHeight: "100vh", display: "grid", placeItems: "center", px: 2, bgcolor: "background.default", boxSizing: "border-box" }}
      >
        <Paper elevation={0} sx={{ maxWidth: 460, width: "100%", p: { xs: 3, sm: 4 }, borderRadius: 4, border: `1px solid ${brand.line}` }}>
          <Box sx={{ width: 48, height: 48, borderRadius: 3, display: "grid", placeItems: "center", bgcolor: brand.canvas, color: brand.ink, mb: 2 }}>
            <StorageRoundedIcon />
          </Box>
          <Typography variant="h5" component="h1" sx={{ fontWeight: 700, mb: 1 }}>
            {workspace ? `No database in ${workspace}` : "No database yet"}
          </Typography>
          <Typography color="text.secondary" sx={{ mb: elsewhere.length ? 2 : 3 }}>
            {workspace
              ? `${workspace} doesn't give you a database to open. Ask its admin, or carry on in another workspace.`
              : "You don't have access to any database yet. Ask your workspace admin."}
            {email ? ` You're signed in as ${email}.` : ""}
          </Typography>
          {elsewhere.length > 0 && (
            <Stack spacing={1} sx={{ mb: 3 }}>
              {elsewhere.map((one) => (
                <Button key={one.id} variant="outlined" onClick={() => onChooseWorkspace(one.id)} sx={{ justifyContent: "flex-start" }}>
                  Open {one.name}
                </Button>
              ))}
            </Stack>
          )}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <Button variant="contained" onClick={onRetry}>
              Try again
            </Button>
            <Button variant="outlined" onClick={onSignOut}>
              Sign out
            </Button>
          </Stack>
        </Paper>
      </Box>
    </ThemeProvider>
  );
}
